import { h as howlerExports } from '../_virtual/howler.js';
import { AudioPlayerStatus } from './audio-player.enum.js';
import { isFunction } from '../node_modules/.pnpm/is-what@5.5.0/node_modules/is-what/dist/isFunction.js';

howlerExports.Howler.html5PoolSize = 100;
class AudioPlayer extends howlerExports.Howl {
  constructor(options) {
    options = { ...AudioPlayer.DefaultOptions, ...options };
    super(options);
    this.options = options;
    this.initEvents();
  }
  _error = void 0;
  _status = AudioPlayerStatus.UNLOADED;
  _soundId = void 0;
  _eventListeners = {
    errorchange: [],
    statuschange: [],
    load: [],
    play: [],
    end: [],
    pause: [],
    stop: [],
    mute: [],
    volume: [],
    rate: [],
    seek: [],
    fade: [],
    unlock: [],
    loaderror: [],
    playerror: []
  };
  options;
  eventListenerList = this._eventListeners;
  get error() {
    return this._error;
  }
  set error(value) {
    if (value !== this._error) {
      this._error = value;
      this._eventListeners["errorchange"].forEach(
        (callback) => {
          callback(value, this._soundId);
        }
      );
    }
  }
  get status() {
    return this._status;
  }
  set status(value) {
    if (value !== this._status) {
      this._status = value;
      this._eventListeners["statuschange"].forEach(
        (callback) => {
          callback(value, this._soundId);
        }
      );
    }
  }
  get soundId() {
    return this._soundId;
  }
  set soundId(value) {
    if (value !== this._soundId) {
      this._soundId = value;
    }
  }
  initEvents() {
    super.on("loaderror", (soundId, error) => {
      this.soundId = soundId;
      this.error = error;
      this.status = AudioPlayerStatus.LOAD_ERROR;
      this._eventListeners["loaderror"].forEach(
        (callback) => {
          callback(soundId, error);
        }
      );
    });
    super.on("playerror", (soundId, error) => {
      this.soundId = soundId;
      this.error = error;
      this.status = AudioPlayerStatus.PLAY_ERROR;
      this._eventListeners["playerror"].forEach(
        (callback) => {
          callback(soundId, error);
        }
      );
    });
    super.on("load", () => {
      const status = AudioPlayerStatus.fromString(this.state());
      if (status) {
        this.status = status;
      }
      this._eventListeners["load"].forEach((callback) => {
        callback();
      });
    });
    super.on("play", (soundId) => {
      this.soundId = soundId;
      this.status = AudioPlayerStatus.PLAYING;
      this._eventListeners["play"].forEach((callback) => {
        callback(soundId);
      });
    });
    super.on("pause", (soundId) => {
      this.soundId = soundId;
      this.status = AudioPlayerStatus.PAUSING;
      this._eventListeners["pause"].forEach((callback) => {
        callback(soundId);
      });
    });
    super.on("stop", (soundId) => {
      this.soundId = soundId;
      this.status = AudioPlayerStatus.STOPPING;
      this._eventListeners["stop"].forEach((callback) => {
        callback(soundId);
      });
    });
    super.on("end", (soundId) => {
      this.soundId = soundId;
      this.status = AudioPlayerStatus.ENDED;
      this._eventListeners["end"].forEach((callback) => {
        callback(soundId);
      });
    });
    super.on("mute", (soundId) => {
      this._eventListeners["mute"].forEach((callback) => {
        callback(soundId);
      });
    });
    super.on("volume", (soundId) => {
      this._eventListeners["volume"].forEach((callback) => {
        callback(soundId);
      });
    });
    super.on("rate", (soundId) => {
      this._eventListeners["rate"].forEach((callback) => {
        callback(soundId);
      });
    });
    super.on("seek", (soundId) => {
      this._eventListeners["seek"].forEach((callback) => {
        callback(soundId);
      });
    });
    super.on("fade", (soundId) => {
      this._eventListeners["fade"].forEach((callback) => {
        callback(soundId);
      });
    });
    super.on("unlock", (soundId) => {
      this._eventListeners["unlock"].forEach((callback) => {
        callback(soundId);
      });
    });
  }
  replaceEventListeners(eventListeners) {
    Object.keys(eventListeners).forEach((key) => {
      const listeners = this._eventListeners[key];
      listeners.splice(
        0,
        listeners.length,
        ...eventListeners[key]
      );
    });
  }
  on(event, callback) {
    this._eventListeners[event].unshift(callback);
    return this;
  }
  off(event, callback) {
    if (event) {
      if (!callback) {
        this._eventListeners[event].splice(0);
      } else if (isFunction(callback)) {
        const listeners = this._eventListeners[event];
        for (let i = listeners.length - 1; i >= 0; i--) {
          if (listeners[i] === callback) {
            listeners.splice(i, 1);
          }
        }
      }
    } else {
      Object.keys(this._eventListeners).forEach((key) => {
        this._eventListeners[key].splice(
          0
        );
      });
    }
    return this;
  }
  once(event, callback) {
    const wrapper = (...args) => {
      callback.apply(this, args);
      this.off(event, wrapper);
    };
    this._eventListeners[event].unshift(wrapper);
    return this;
  }
  static DefaultOptions = {
    src: [],
    html5: true,
    preload: "metadata"
  };
}

export { AudioPlayer };
//# sourceMappingURL=audio-player.js.map
